var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["core-video-icon.j2"] = require( "core-video-icon.j2" );
dependencies["contentful/ugc-video-component.j2"] = require( "contentful/ugc-video-component.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-display-tile-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"video")) {
output += "\n\n    <span class=\"c-ugc-tray__video-icon js-ugc-video-icon\">\n\n        ";
env.getTemplate("core-video-icon.j2", false, "core/templates/contentful/ugc-display-tile-content.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n    </span>\n\n    ";
env.getTemplate("contentful/ugc-video-component.j2", false, "core/templates/contentful/ugc-display-tile-content.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n";
})})})});
}
else {
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "lazy")) {
output += "\n        <img data-src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "largePhotoUrl"), env.opts.autoescape);
output += "\" class=\"c-ugc-tray__image js-lazy\" data-qa-ugc-image />\n    ";
;
}
else {
output += "\n        <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "largePhotoUrl"), env.opts.autoescape);
output += "\" class=\"c-ugc-tray__image\" data-qa-ugc-image />\n    ";
;
}
output += "\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-display-tile-content.j2"] , dependencies)